import React from "react";
import Login from "./Login";
import "./Login.css";

function Home() {
  return (
    <main className="assure-home">
      <div
        className="assure-home__image"
        aria-hidden="true"
        style={{ backgroundImage: "url('/assure.jpg')" }}
      ></div>

      <div className="assure-home__shade" aria-hidden="true"></div>

      <header className="assure-header">
        <div className="assure-product">
          <img
            src="/bronix-logo.png"
            alt="Bronix Technologies"
            className="assure-product__logo"
          />

          <div className="assure-product__name">
            <strong>NetriAssure</strong>
            <small>Life & Funeral Assurance Platform</small>
          </div>
        </div>

        <div className="assure-header__status">
          <span></span>
          Secure system access
        </div>
      </header>

      <section className="assure-home__content">
        <div className="assure-story">
          <p className="assure-story__eyebrow">
            Protection that honours every life
          </p>

          <h1>
            Cover built around
            <span>people, dignity and tomorrow.</span>
          </h1>

          <p className="assure-story__summary">
            NetriAssure brings member administration, policy servicing,
            premium collection, beneficiaries and claims into one secure
            operational platform.
          </p>

          <div className="assure-story__promise">
            <span className="assure-story__promise-line"></span>
            <p>
              Every policy represents a family, a promise and a future
              worth protecting.
            </p>
          </div>
        </div>

        <aside className="assure-access">
          <Login />
        </aside>
      </section>

      <footer className="assure-footer">
        <span>NetriAssure</span>
        <span className="assure-footer__divider"></span>
        <a
          href="https://bronixtechnologies.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Developed by Bronix Technologies
        </a>
      </footer>
    </main>
  );
}

export default Home;
